/**
 * RotaSlaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {RotaSla} from '@/model/resource/RotaSla'

/* TODO: review generated class */
@HttpExclude()
export class RotaSlaCollection extends PageCollection<RotaSla> {
  constructor() {
    super(RotaSla)
  }

  queryAsPage() {
    return this.listRotaSla()
  }

  async listRotaSla() {
    return await Request.get(`/admin/rota-sla`, {params: this.params})
      .name('listRotaSla')
      .as(this)
      .getResponse()
  }

  async listCsvRotaSla() {
    return await Request.get(`/admin/rota-sla/csv`, {params: this.params})
      .name('listCsvRotaSla')
      .as(this)
      .getResponse()
  }
}
